
import React, { useState, useEffect } from 'react';
import appointmentService from '../../services/http/appointments/appointment.service';


interface PaymentStatusResponse {
    success: boolean;
    status: 'BOOKING_SUCCESS' | 'BOOKING_FAILED' | 'TRANSACTION_FAILED' | 'TRANSACTION_CANCELLED';
    orderId: string;
    transactionId?: string;
    amount: number;
    drWhatsappLink?: string;
    drWhatsappNumber?: string;
    practitionerName: string;
    appointmentDate?: string;
    errorMessage?: string;
    message?: string;
    time?: string;
    statusName?: string;
}

const PaymentStatusPageOnline = () => {
    const [statusData, setStatusData] = useState<PaymentStatusResponse | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    // Extract orderId from URL params or search params
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const orderIdParam = urlParams.get('order_id');
        console.log('orderIdFromUrl', orderIdParam);
        if (orderIdParam) {
            checkPaymentStatus(orderIdParam);
        } else {
            setError('Order ID is required');
            setLoading(false);
        }
    }, []);

    const checkPaymentStatus = async (orderId: string) => {
        try {
            setLoading(true);

            const data: PaymentStatusResponse = await appointmentService.getCashfreeStatusOnline(orderId);
            console.log('Payment status data:', data);

            if (data.success) {
                setStatusData(data);
            } else {
                setError(data.message || 'Failed to check payment status');
            }
        } catch (err) {
            setError('Unable to verify payment. Please contact support.');
            console.error('Payment status check error:', err);
        } finally {
            setLoading(false);
        }
    };

    // const formatDate = (dateString: string | undefined): string => {
    //     if (!dateString) return '';
    //     return new Date(dateString).toLocaleString('en-IN', {
    //         day: '2-digit',
    //         month: '2-digit',
    //         year: 'numeric',
    //         hour: '2-digit',
    //         minute: '2-digit',
    //     });
    // };
     const renderInstructions = () => {
    if (!statusData) return null;
    
    return (
      <ol className="text-gray-600 space-y-3 pl-5">
        <li>
          Please WhatsApp your name, age, approximate weight, complaints, reports & previous prescription if any.{' '}
          {statusData.drWhatsappLink && statusData.drWhatsappNumber && (
            <a 
              href={statusData.drWhatsappLink}
              className="font-bold text-gray-700 italic hover:text-blue-600"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here to WhatsApp doctor @ 
            </a>
          )}
        </li>
        <li>
          Your doctor will call you on your registered mobile number
        </li>
        <li>
          Do not call the doctor as he/she maybe in a middle of a Digital Consultation
        </li>
        <li>
          This Consultation/Chat is valid for the next 48 hrs, please feel free to post any queries but avoid calls
        </li>
        <li>
          If in case you have booked for someone else or texting from different phone no., kindly share the registered mobile no. to the doctor for his/her reference
        </li>
    
      </ol>
    );
  };

    const renderStatusIcon = (status: string | undefined) => {
        switch (status) {
            case 'BOOKING_SUCCESS':
                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '90px', color: '#3492C3', marginBottom: '0.5rem' }}>
                            ✓
                        </div>
                        <span style={{ color: '#3492C3', fontSize: '20px', fontWeight: '700' }}>
                            Successfully Booked
                        </span>
                    </div>
                );
            case 'BOOKING_FAILED':
                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '90px', color: 'red', marginBottom: '0.5rem' }}>
                            ✕
                        </div>
                        <span style={{ color: 'red', fontSize: '20px', fontWeight: '700' }}>
                            Failed Appointment Booking
                        </span>
                    </div>
                );
            case 'TRANSACTION_FAILED':
                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '90px', color: 'red', marginBottom: '0.5rem' }}>
                            ✕
                        </div>
                        <span style={{ color: 'red', fontSize: '20px', fontWeight: '700' }}>
                            Failed Appointment Booking
                        </span>
                    </div>
                );
            case 'TRANSACTION_CANCELLED':
                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '90px', color: 'red', marginBottom: '0.5rem' }}>
                            ✕
                        </div>
                        <span style={{ color: 'red', fontSize: '20px', fontWeight: '700' }}>
                            Transaction Dropped By User
                        </span>
                    </div>
                );
            default:
                return null;
        }
    };

    const getPageTitle = (status: string | undefined): string => {
        switch (status) {
            case 'BOOKING_SUCCESS':
                return 'Transaction Successful';
            case 'BOOKING_FAILED':
                return 'Appointment Failed';
            case 'TRANSACTION_FAILED':
                return 'Transaction Failed';
            case 'TRANSACTION_CANCELLED':
                return 'Transaction Cancelled';
            default:
                return 'Payment Status';
        }
    };

    const handleRetry = (): void => {
        window.location.reload();
    };

    // const handleRefreshStatus = (): void => {
    //     if (orderId) {
    //         checkPaymentStatus(orderId);
    //     }
    // };

    // const handleTryAgain = (): void => {
    //     window.history.back();
    // };

    // const handleBackToHome = (): void => {
    //     window.location.href = '/';
    // };

    if (loading) {
        return (
            <div style={{
                minHeight: '100vh',
                backgroundColor: '#f9fafb',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        fontSize: '2.5rem',
                        marginBottom: '1rem',
                        animation: 'spin 1s linear infinite'
                    }}>
                        ⟳
                    </div>
                    <div style={{ fontSize: '1.125rem', color: '#6b7280' }}>
                        Checking payment status...
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{
                minHeight: '100vh',
                backgroundColor: '#f9fafb',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{
                    maxWidth: '28rem',
                    width: '100%',
                    backgroundColor: 'white',
                    borderRadius: '0.5rem',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                    padding: '2rem'
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '3.75rem', color: '#ef4444', marginBottom: '1rem' }}>
                            ⚠
                        </div>
                        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                            Error
                        </h2>
                        <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>{error}</p>
                        <button
                            onClick={handleRetry}
                            style={{
                                backgroundColor: '#3b82f6',
                                color: 'white',
                                fontWeight: 'bold',
                                padding: '0.5rem 1rem',
                                borderRadius: '0.25rem',
                                border: 'none',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s'
                            }}
                            onMouseOver={(e: any) => e.target.style.backgroundColor = '#2563eb'}
                            onMouseOut={(e: any) => e.target.style.backgroundColor = '#3b82f6'}
                        >
                            Retry
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
            <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>

            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '15px' }}>
                <div className="row" style={{ display: 'flex', justifyContent: 'center' }}>
                    <div className="col-lg-4"></div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12" style={{ padding: '15px 0px 0px 0px' }}>

                        {/* Logo */}
                        <div style={{ marginBottom: '15px', textAlign: 'center' }}>
                            <img
                                src="/img/logo-transparent.png"
                                alt="Schedula"
                                style={{ height: '50px' }}
                                onError={(e: any) => {
                                    e.target.style.display = 'none';
                                }}
                            />
                        </div>

                        {/* Title */}
                        <div style={{ textAlign: 'center' }}>
                            <div>
                                <h3>{getPageTitle(statusData?.status)}</h3>
                            </div>

                            {/* Status Content */}
                            <div id="booked">
                                {renderStatusIcon(statusData?.status)}
                                <br />
                                <span style={{ color: '#545454', fontSize: '16px', fontWeight: '700' }}>
                                    Digital Consultation
                                </span>
                                <br />
                                <span style={{ color: '#545454', fontSize: '16px', fontWeight: '700' }}>
                                    With{' '}
                                </span>
                                <span id="dname">Dr. {statusData?.practitionerName}</span>

                                {/* Show status for booking failed and transaction cancelled */}
                                {(statusData?.status === 'BOOKING_FAILED' && statusData?.statusName) && (
                                    <>
                                        <br />
                                        <span style={{ color: '#545454', fontSize: '16px', fontWeight: '700' }}>
                                            Status: {statusData.statusName}
                                        </span>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Transaction Details */}
                        <div style={{
                            border: '1px solid #f9f9f9',
                            borderRightColor: 'transparent',
                            padding: '10px 0',
                            borderLeftColor: 'transparent',
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            <div style={{ margin: '5px 0' }}>
                                <span>
                                    <div style={{ textAlign: 'center' }}>
                                        <span style={{ marginRight: '4px' }}>₹</span>
                                        <span id="money">{statusData?.amount}</span>
                                    </div>
                                </span>
                            </div>

                            {/* Transaction ID and Time - only for transactions with ID */}
                            {statusData?.transactionId && statusData?.status !== 'TRANSACTION_CANCELLED' && (
                                <>
                                    <span style={{ color: '#7c7c7c' }}>Transaction ID: </span>
                                    <span id="taxnid" style={{ color: '#404040' }}>{statusData.transactionId}</span>
                                    <br />
                                    {statusData?.time && (
                                        <span id="transdate" style={{ color: '#7c7c7c' }}>{statusData.time}</span>
                                    )}
                                </>
                            )}
                        </div>


                        {/* Support Information */}
                        <div style={{ padding: '0px 20px' }}>
                            {statusData?.status === 'BOOKING_SUCCESS' ? (
                                <span style={{ color: '#727272' }}>
                                    <b>Steps to follow for your digital Consultation:</b>
                                    {renderInstructions()}

                                    For any technical queries, contact <i>Schedula Services</i> at 04448133022 or email to support@schedula.in
                                </span>
                            ) : (
                                    <div style={{ color: '#727272' }}>
                                        For any technical queries, contact <i>Schedula Services</i> at 04448133022 or email to support@schedula.in
                                    </div>

                            )}
                        </div>

                        {/* WhatsApp Button for Success */}
                        {statusData?.status === 'BOOKING_SUCCESS' && statusData?.drWhatsappLink && (
                            <div
                                style={{
                                    position: 'fixed',
                                    bottom: 0,
                                    left: 0,
                                    width: '100%',
                                    backgroundColor: '#008be0',
                                    zIndex: 999,
                                    textAlign: 'center'
                                }}
                            >
                                <a
                                    href={statusData.drWhatsappLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: 'block',
                                        padding: '15px 0',
                                        color: 'white',
                                        fontWeight: '600',
                                        textDecoration: 'none',
                                        fontSize: '18px'
                                    }}
                                >
                                    WhatsApp Doctor
                                </a>
                            </div>
                        )}


                    </div>
                    <div className="col-lg-4"></div>
                </div>
            </div>
        </div>
    );
};

export default PaymentStatusPageOnline;

// import React, { useState, useEffect } from 'react';
// import appointmentService from '../../services/http/appointments/appointment.service';


// interface PaymentStatusResponse {
//   success: boolean;
//   status: 'BOOKING_SUCCESS' | 'BOOKING_FAILED' | 'TRANSACTION_FAILED' | 'TRANSACTION_CANCELLED';
//   orderId: string;
//   transactionId?: string;
//   amount: number;
//   practitionerName: string;
//   drWhatsappNumber?: string;
//   drWhatsappLink?: string;
//   appointmentDate?: string;
//   errorMessage?: string;
//   message?: string;
//   time?: string;
//   statusName?: string;
// }

// const PaymentStatusPageOnline = () => {
//   const [statusData, setStatusData] = useState<PaymentStatusResponse | null>(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const orderIdParam = urlParams.get('order_id');
    
//     if (orderIdParam) {
//       checkPaymentStatus(orderIdParam);
//     } else {
//       setError('Order ID is required');
//       setLoading(false);
//     }
//   }, []);

//   const checkPaymentStatus = async (orderId: string) => {
//     try {
//       setLoading(true);
      
//       const data: PaymentStatusResponse = await appointmentService.getCashfreeStatusOnline(orderId);
      
//       if (data.success) {
//         setStatusData(data);
//       } else {
//         setError(data.message || 'Failed to check payment status');
//       }
//     } catch (err) {
//       setError('Unable to verify payment. Please contact support.');
//       console.error('Payment status check error:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderInstructions = () => {
//     if (!statusData) return null;
    
//     return (
//       <ol className="text-gray-600 space-y-3 pl-5">
//         <li>
//           Please WhatsApp your name, age, approximate weight, complaints, reports & previous prescription if any.{' '}
//           {statusData.drWhatsappLink && statusData.drWhatsappNumber && (
//             <a 
//               href={statusData.drWhatsappLink}
//               className="font-bold text-gray-700 italic hover:text-blue-600"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               Click here to WhatsApp doctor @ {statusData.drWhatsappNumber}
//             </a>
//           )}
//         </li>
//         <li>
//           Your doctor will call you on your registered mobile number
//         </li>
//         <li>
//           Do not call the doctor as he/she maybe in a middle of a Digital Consultation
//         </li>
//         <li>
//           This Consultation/Chat is valid for the next 48 hrs, please feel free to post any queries but avoid calls
//         </li>
//         <li>
//           If in case you have booked for someone else or texting from different phone no., kindly share the registered mobile no. to the doctor for his/her reference
//         </li>
        
//         <li className="text-gray-600 mt-4">
//           For any technical queries, contact <span className="italic">Schedula Services</span> at 04448133022 or email to support@schedula.in
//         </li>
//       </ol>
//     );
//   };

//   const renderStatusIcon = (status: string | undefined) => {
//     switch (status) {
//       case 'BOOKING_SUCCESS':
//         return (
//           <div className="text-center">
//             <div className="text-[#3492C3] text-8xl mb-4">✓</div>
//             <div className="text-[#3492C3] text-xl font-bold mb-2">Successfully Booked</div>
//           </div>
//         );
//       case 'BOOKING_FAILED':
//         return (
//           <div className="text-center">
//             <div className="text-red-500 text-8xl mb-4">✕</div>
//             <div className="text-red-500 text-xl font-bold mb-2">Failed Appointment Booking</div>
//           </div>
//         );
//       case 'TRANSACTION_FAILED':
//         return (
//           <div className="text-center">
//             <div className="text-red-500 text-8xl mb-4">✕</div>
//             <div className="text-red-500 text-xl font-bold mb-2">Failed Appointment Booking</div>
//           </div>
//         );
//       case 'TRANSACTION_CANCELLED':
//         return (
//           <div className="text-center">
//             <div className="text-orange-500 text-8xl mb-4">✕</div>
//             <div className="text-orange-500 text-xl font-bold mb-2">Transaction Dropped By User</div>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   const getPageTitle = (status: string | undefined): string => {
//     switch (status) {
//       case 'BOOKING_SUCCESS':
//         return 'Transaction Successful';
//       case 'BOOKING_FAILED':
//         return 'Appointment Failed';
//       case 'TRANSACTION_FAILED':
//         return 'Transaction Failed';
//       case 'TRANSACTION_CANCELLED':
//         return 'Transaction Cancelled';
//       default:
//         return 'Payment Status';
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
//         <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
//           <div className="text-blue-500 text-6xl mb-4 animate-spin inline-block">⟳</div>
//           <p className="text-gray-600 text-lg">Checking payment status...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
//         <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
//           <div className="text-center mb-6">
//             <div className="text-yellow-500 text-6xl mb-4">⚠</div>
//             <h2 className="text-2xl font-bold text-gray-800 mb-2">Error</h2>
//             <p className="text-gray-600">{error}</p>
//           </div>
//           <button
//             onClick={() => window.location.reload()}
//             className="w-full bg-blue-500 text-white py-3 px-6 rounded hover:bg-blue-600 transition-colors"
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 py-8 px-4">
//       <div className="max-w-lg mx-auto">
//         {/* Logo */}
//         <div className="text-center mb-6">
//           <img
//             src="/img/logo-transparent.png"
//             alt="Schedula"
//             className="h-12 mx-auto"
//             onError={(e) => {
//               e.currentTarget.style.display = 'none';
//             }}
//           />
//         </div>

//         <div className="bg-white rounded-lg shadow-lg overflow-hidden">
//           {/* Title */}
//           <div className="bg-white p-6 text-center border-b">
//             <h3 className="text-2xl font-bold text-gray-800">
//               {getPageTitle(statusData?.status)}
//             </h3>
//           </div>

//           {/* Status Icon */}
//           <div className="p-6 text-center">
//             {renderStatusIcon(statusData?.status)}
//             <div className="mt-4">
//               <div className="text-gray-700 text-base font-bold">Digital Consultation</div>
//               <div className="text-gray-700 text-base font-bold">
//                 With <span>Dr. {statusData?.practitionerName}</span>
//               </div>
//             </div>

//             {/* Status Name for Failed Cases */}
//             {(statusData?.status === 'BOOKING_FAILED' && statusData?.statusName) && (
//               <div className="mt-4 text-gray-600">
//                 Status: <span className="font-semibold">{statusData.statusName}</span>
//               </div>
//             )}
//           </div>

//           {/* Transaction Details */}
//           {statusData?.status === 'BOOKING_SUCCESS' && (
//             <div className="border-t border-b border-gray-100 py-4 text-center">
//               <div className="mb-2">
//                 <span className="text-2xl font-bold text-gray-800">
//                   ₹ {statusData?.amount}
//                 </span>
//               </div>
//               {statusData?.transactionId && (
//                 <>
//                   <div className="text-gray-500 text-sm">
//                     Transaction ID:{' '}
//                     <span className="text-gray-700 font-medium">{statusData.transactionId}</span>
//                   </div>
//                   {statusData?.time && (
//                     <div className="text-gray-500 text-sm mt-1">{statusData.time}</div>
//                   )}
//                 </>
//               )}
//             </div>
//           )}

//           {/* Instructions */}
//           {statusData?.status === 'BOOKING_SUCCESS' && (
//             <div className="p-6">
//               <h6 className="font-semibold text-gray-800 mb-4">
//                 Steps to follow for your digital Consultation:
//               </h6>
//               {renderInstructions()}
//             </div>
//           )}

//           {/* WhatsApp Button for Success */}
//           {statusData?.status === 'BOOKING_SUCCESS' && statusData?.drWhatsappLink && (
//             <div className="p-6 pt-0">
//               <a
//                 href={statusData.drWhatsappLink}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="block w-full bg-[#008be0] text-white text-center py-4 font-semibold hover:bg-[#007bc7] transition-colors"
//               >
//                 WhatsApp Doctor
//               </a>
//             </div>
//           )}

//           {/* Support Info for Failed Cases */}
//           {statusData?.status !== 'BOOKING_SUCCESS' && (
//             <div className="p-6 bg-gray-50 text-sm text-gray-600">
//               For any technical queries, contact <span className="font-semibold">Schedula Services</span> at 
//               <span className="font-semibold"> 04448133022 </span> or email to{' '}
//               <a href="mailto:support@schedula.in" className="text-blue-600 hover:underline">
//                 support@schedula.in
//               </a>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaymentStatusPageOnline;